import React, {FC, useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {Button} from "primereact/button";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {routes} from "../../../app/routes";
import TextInput from "../../../components/form/TextInput";
import {
    useCreateCustomerMutation,
    useFindCustomerByIdQuery,
    useUpdateCustomerMutation
} from "../../../api/eventsStoreApi";
import {
    initialCustomerState,
    selectSettingState, setCustomerProperty,
    setSettingData
} from "../../../slices/settingsSlice";
import {ProgressSpinner} from "primereact/progressspinner";

const UpdateCustomer: FC<{}> = ({}) => {
    const {id = ""} = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {isLoading: isPrepareLoading} = useFindCustomerByIdQuery(
        {id: id},
        {skip: id === ""}
    );
    const [
        updateCustomer,
        {isLoading: isUpdateLoading, isSuccess: isUpdateSuccess},
    ] = useUpdateCustomerMutation();
    const [
        createCustomer,
        {isLoading: isCreateLoading, isSuccess: isCreateSuccess},
    ] = useCreateCustomerMutation();

    const {customer} = useAppSelector(selectSettingState);
    const {name} = customer;

    const isSuccess = isUpdateSuccess || isCreateSuccess;

    useEffect(() => {
        dispatch(setSettingData({property: "customer", value: initialCustomerState}));

        if (isSuccess) {
            navigate(`/${routes.SETTINGS}/${routes.CUSTOMERS}`);
        }
    }, [navigate, isSuccess]);

    const onSubmit = () => {
        !!id
            ? updateCustomer({id: id, customerDto: customer})
            : createCustomer({customerDto: customer});
    };

    return (
        <>
            <div className="grid m-5">
                <h3 className="text-center p-1 mt-0">
                    {!id
                        ? `Add customer`
                        : `Update customer ${name}`}
                </h3>
                <TextInput
                    id="name"
                    name="name"
                    value={name}
                    label="Nazwa"
                    setProperty={setCustomerProperty}
                />
                {isCreateLoading || isUpdateLoading ?
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><ProgressSpinner/>
                    </div> : <Button label="Save" className="mt-5 w-full" onClick={onSubmit}/>}
            </div>
        </>
    );
};

export default UpdateCustomer;
